<template>
    <div class="ion-page">
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    
                    <ion-title class="fontRoboto" v-if="mode!='Update'">Add New User</ion-title>
                    <ion-title class="fontRoboto" v-if="mode=='Update'">{{ name }} Info</ion-title>
                    <ion-button class="margin-top-10 close-btn"  @click="navigatePreviousPage">Close
                        <!-- <ion-icon :icon="refresh"></ion-icon>
                        <ion-back-button default-href="#" v-if="!displayBackBtn"></ion-back-button> -->
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <div class="rectangle">
                <ion-grid class="rectangle">
                    <ion-row class="row-divider"></ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">Name<span class="required">*</span></ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Your Name"
                                    @input="name = $event.target.value"
                                    :value="name"
                                    maxlength="50"
                                    :readonly = "mode == 'Update' ? true : false" 
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">Email Address<span class="required">*</span></ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="email"
                                    placeholder="Enter Email Address"
                                    @input="email = $event.target.value"
                                    :value="email"
                                    maxlength="200"
                                    :readonly = "mode == 'Update' ? true : false" 
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">Mobile Number<span class="required">*</span></ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="tel"
                                    placeholder="Enter Mobile Number"
                                    @input="mobile = $event.target.value"
                                    :value="mobile"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="secondary-text">Address</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                Building Name
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Building Name"
                                    @input="line1 = $event.target.value"
                                    :value="line1"
                                    maxlength="100"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                Street Address
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Street Address"
                                    @input="line2 = $event.target.value"
                                    :value="line2"
                                    maxlength="100"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                Area Name
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Area Name"
                                    @input="line3 = $event.target.value"
                                    :value="line3"
                                    maxlength="100"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                City
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter City"
                                    @input="city = $event.target.value"
                                    :value="city"
                                    maxlength="100"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                State
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter City"
                                    @input="state = $event.target.value"
                                    :value="state"
                                    maxlength="100"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-label class="border-text" position="stacked">
                                Pincode
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Pincode"
                                    @input="zipcode = $event.target.value"
                                    :value="zipcode"
                                    maxlength="6"
                                    :readonly = "readonlyInput == true ? 'true' : flase"
                                ></ion-input>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col class="col-padding">
                            <ion-label class="border-text" position="stacked">
                                Status
                                <span class="required">*</span>
                            </ion-label>
                            <div class="border-line select-mobile">
                                <ion-select
                                    class="form-select popover-content"
                                    :value="status"
                                    @ionChange="status = $event.target.value"
                                    placeholder="Select State"
                                    interface="action-sheet"
                                    :disabled = "readonlyInput == true ? 'true' : flase"
                                >
                                    <ion-select-option
                                    v-for="(status, index) in this.userStatus"
                                    :key="index"
                                    :value="status.code"
                                    >{{status.name}}</ion-select-option>
                                </ion-select>
                            </div>
                            <div class="border-line select-web">
                                <select class="input-select select-s" v-model="status" placeholder="Select State" :disabled = "readonlyInput == true ? 'true' : flase">
                                    <option
                                    v-for="(status, index) in this.userStatus"
                                    :key="index"
                                    :value="status.code"
                                    >{{ status.name }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col></ion-col>
                        <ion-col></ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col></ion-col>
                        <ion-col v-if="mode != 'Update'">
                            <div class= "ion-text-center" >
                                <ion-button class="btn-primary1" expand="block" @click="saveNewProfile">Save</ion-button>
                            </div>
                        </ion-col>
                        <ion-col v-if="mode == 'Update'">
                            <div class= "ion-text-center" >
                                <ion-button class="btn-primary1" expand="block" @click="updateProfile">Update</ion-button>
                            </div>
                        </ion-col>
                        <ion-col></ion-col>
                    </ion-row>
                    
                </ion-grid>
            </div>
            <div v-if="mode == 'Update'">
                <ion-grid class="rectangle">
                    <ion-row>
                        <ion-col>
                            <ion-label>Credentials</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="rectangle">
                        <ion-col>
                            <ion-label class="section-item" position="stacked">Password</ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    :type="passwordType"
                                    placeholder="Password"
                                    @input="password = $event.target.value"
                                    :value="password"
                                    maxlength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col>
                            <ion-button class="btn-clear" @click="passwordDisplay">
                                <ion-icon :icon="eyeOutline" v-if="showPassword"></ion-icon>
                                <ion-icon :icon="eyeOffOutline" v-if="!showPassword"></ion-icon>
                            </ion-button>
                        </ion-col>
                        <ion-col></ion-col>
                    </ion-row>
                    <ion-row class="row-divider"></ion-row>
                    <ion-row class="rectangle">
                        <ion-col v-if="!displayResetPwd">
                            <ion-button class="btn-clear1" @click="displayResetOption">
                                Reset Password
                            </ion-button>
                        </ion-col>
                        <ion-col v-if="displayResetPwd">
                            <ion-label class="section-item" position="stacked">New Password</ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="password"
                                    placeholder="New Password"
                                    @input="newPassword = $event.target.value"
                                    :value="newPassword"
                                    maxlength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col v-if="displayResetPwd">
                            <ion-label class="section-item" position="stacked">Confirm Password</ion-label>
                            <div class="border-line">
                                <ion-input
                                    class="form-input"
                                    type="password"
                                    placeholder="Confirm Password"
                                    @input="confirmPassword = $event.target.value"
                                    :value="confirmPassword"
                                    maxlength="50"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col v-if="displayResetPwd">
                            <ion-button class="btn-clear" @click="resetPassword">
                                Reset
                            </ion-button>
                            <ion-button class="btn-clear" @click="displayResetOption">
                                Cancel
                            </ion-button>
                            
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            
        </ion-content>
    </div>
</template>

<script>
import { defineComponent, render } from "vue";
import { refresh, add, eyeOutline, eyeOffOutline } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { flash } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import userData from "../../../public/assets/data/data.json";
import { ValidationUtils } from "../../util/validation-utils";

export default defineComponent ({
    name: 'carterProfileEdit',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            refresh,
            add,
            eyeOutline,
            eyeOffOutline,
            showPassword: false,
            displayInd: true,
            displayBackBtn: false,
            loaderTab: true,
            users: userData.usersList,
            userStatus: [{"code" : "A", "name" : "Active"}, {"code" : "IN", "name" : "Inactive"},{"code" : "TEMIN", "name" : "Temporarily Inactive"}],
            userId:"",
            name : '',
            states: "",
            mobile: "",
            email: "",
            firstName: "",
            lastName: "",
            gender: "",
            dob: "",
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            zipcode: "",
            status: "",
            norecordsfound: false,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            usersList: [],
            displayBackBtn: false,
            userDetails: {},
            mode : "NEW",
            password: "Password@123",
            passwordType: 'password',
            newPassword: "",
            confirmPassword: "",
            displayResetPwd: false
        }
    },
    async mounted() {
        this.mode = localStorage.getItem('profileMode');
        if(this.mode == 'Update') {
            let userDetails = JSON.parse(localStorage.getItem('userDetails'));
            if(userDetails != null) {
                this.fillUserDetails(userDetails)
                
            }
        } else {
            this.mode = 'New'
        }
        
        // let userDetails = JSON.parse(localStorage.getItem('userDetails'));
        // if(userDetails != null) {
        //     this.mode= "UPDATE"
        //     this.fillUserDetails(userDetails)
        // } else {
        //     this.usersList = this.users;
        //     localStorage.setItem("usersList" , JSON.stringify(this.usersList));
        // }
    },
    
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        changeDateFormat(dateValue) {
            return moment(dateValue).format('YYYY-MM-DD HH:mm:ss')
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        fillUserDetails(userData){
            this.userId = userData.id;
            this.name = userData.firstName;
            this.email = userData.email;
            this.mobile = userData.mobile;
            this.line1 = userData.address.line1;
            this.line2 = userData.address.line2;
            this.line3 = userData.address.line3;
            this.city = userData.address.city;
            this.state = userData.address.state.name;
            this.zipcode = userData.address.zipcode;
            this.status = userData.status.code;
            let pwd = localStorage.getItem(this.userId+"userPwd")
            if(pwd != null) {
                this.password = pwd
            } 

        },
        passwordDisplay() {
            if(this.showPassword){
                this.showPassword = false;
                this.passwordType = 'password'
            } else {
                this.showPassword = true;
                this.passwordType = 'text'
                
            }
        },
        updateProfile() {
            try {
                if(
                    typeof this.name === "undefined" ||
                    this.name === null ||
                    this.name === "" ||
                    this.name.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Your Name");
                }  
                else if (
                    typeof this.email === "undefined" ||
                    this.email === null ||
                    this.email === "" ||
                    this.email.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Valid Email Address");
                } else if (
                    typeof this.mobile === "undefined" ||
                    this.mobile === null ||
                    this.mobile === "" ||
                    this.mobile.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Mobile Number");
                } else if (
                    typeof this.line1 === "undefined" ||
                    this.line1 === null ||
                    this.line1 === "" ||
                    this.line1.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Build Name and No");
                } else if (
                    typeof this.line2 === "undefined" ||
                    this.line2 === null ||
                    this.line2 === "" ||
                    this.line2.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Street");
                } else if (
                    typeof this.line3 === "undefined" ||
                    this.line3 === null ||
                    this.line3 === "" ||
                    this.line3.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Area Name");
                } else if (
                    typeof this.city === "undefined" ||
                    this.city === null ||
                    this.city === "" ||
                    this.city.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter City");
                } else if (
                    typeof this.state === "undefined" ||
                    this.state === null ||
                    this.state === ""
                ) {
                    new ToastUtils().presentToast("Select State");
                }else if (
                    typeof this.zipcode === "undefined" ||
                    this.zipcode === null ||
                    this.zipcode === "" ||
                    this.zipcode.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Zipcode");
                } else {
                    let usersList = JSON.parse(localStorage.getItem('usersList'));
                    for(let i = 0; i< usersList.length; i++) {
                        if(usersList[i].firstName == this.name && usersList[i].email == this.email) {
                            if (i > -1) { // only splice array when item is found
                                usersList.splice(i, 1); // 2nd parameter means remove one item only

                                this.loaderTab = true; 
                                let userDetails = {
                                    "id" : this.userId,
                                    "firstName":this.name,
                                    "mobile":this.mobile,
                                    "address":
                                    {
                                        "line1": this.line1,
                                        "line2":this.line2,
                                        "line3":this.line3,
                                        "city":this.city,
                                        "state":
                                        {
                                            "code":this.state,
                                            "name" : this.state
                                        },
                                        "zipcode":this.zipcode
                                    },
                                    "email":this.email,
                                    "status" : {
                                        "code" : this.status,
                                        "name" : this.status == 'A' ? 'Active' : this.status == 'IN' ? 'Inactive' : 'Temporarily Inactive'
                                    }
                                } 
                                this.usersLis = [];
                                this.usersList.push(userDetails);
                                // console.log(this.usersList)
                                for(let i = 0; i<usersList.length; i++) {
                                    this.usersList.push(usersList[i])
                                }
                                localStorage.removeItem('userDetails');
                                localStorage.removeItem('usersList')
                                localStorage.setItem("userDetails", JSON.stringify(userDetails))
                                localStorage.setItem("usersList", JSON.stringify(this.usersList))

                            }
                            break;
                        }
                    }
                    new ToastUtils().presentToast("Profile updated successfully");
                }
            } catch(error) {
                alert(error)
            }
        },
        saveNewProfile() {
            try {
                if(
                    typeof this.name === "undefined" ||
                    this.name === null ||
                    this.name === "" ||
                    this.name.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Your Name");
                }  
                else if (
                    typeof this.email === "undefined" ||
                    this.email === null ||
                    this.email === "" ||
                    this.email.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Valid Email Address");
                } else if (
                    typeof this.mobile === "undefined" ||
                    this.mobile === null ||
                    this.mobile === "" ||
                    this.mobile.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Mobile Number");
                } else if (
                    typeof this.line1 === "undefined" ||
                    this.line1 === null ||
                    this.line1 === "" ||
                    this.line1.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Build Name and No");
                } else if (
                    typeof this.line2 === "undefined" ||
                    this.line2 === null ||
                    this.line2 === "" ||
                    this.line2.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Street");
                } else if (
                    typeof this.line3 === "undefined" ||
                    this.line3 === null ||
                    this.line3 === "" ||
                    this.line3.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Area Name");
                } else if (
                    typeof this.city === "undefined" ||
                    this.city === null ||
                    this.city === "" ||
                    this.city.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter City");
                } else if (
                    typeof this.state === "undefined" ||
                    this.state === null ||
                    this.state === ""
                ) {
                    new ToastUtils().presentToast("Select State");
                }else if (
                    typeof this.zipcode === "undefined" ||
                    this.zipcode === null ||
                    this.zipcode === "" ||
                    this.zipcode.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Zipcode");
                } 
                else if(this.status == '' || this.status == null || this.status == undefined) {
                    new ToastUtils().presentToast("Select status");
                } else {
                    try {
                        let usersList = JSON.parse(localStorage.getItem('usersList'));
                        this.loaderTab = true; 
                        let userDetails = {
                            "id" : usersList.length + 1,
                            "firstName":this.name,
                            "mobile":this.mobile,
                            "address":
                            {
                                "line1": this.line1,
                                "line2":this.line2,
                                "line3":this.line3,
                                "city":this.city,
                                "state":
                                {
                                    "code":this.state,
                                    "name" : this.state
                                },
                                "zipcode":this.zipcode
                            },
                            "email":this.email,
                            "status" : {
                                "code" : "A",
                                "name" : "Active"
                            }
                        } 
                        this.usersList.push(userDetails);
                        // console.log(this.usersList)
                        for(let i = 0; i<usersList.length; i++) {
                            this.usersList.push(usersList[i])
                        }
                        localStorage.setItem("usersList", JSON.stringify(this.usersList))
                        // console.log(this.usersList)
                        this.$router.go(-1)
                                    
                        new ToastUtils().presentToast("Profile saved successfully");
                    } catch(er) {
                        alert(er)
                    }
                    
                }
            } catch (error) {
                new ToastUtils().presentToast(error.response.data.errors[0].detail)
            }
        },
        resetPassword() {
            if(
                typeof this.newPassword === "undefined" ||
                this.newPassword === null ||
                this.newPassword === "" ||
                this.newPassword.trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter New Password");
            } else if(this.newPassword.trim().length < 7
            ) {
                new ToastUtils().presentToast("New Password length min 8 characters");
            }  else if(
                typeof this.confirmPassword === "undefined" ||
                this.confirmPassword === null ||
                this.confirmPassword === "" ||
                this.confirmPassword.trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter Confirm Password");
            } else if(this.newPassword !== this.confirmPassword) {
                new ToastUtils().presentToast("Passwords do NOT match");
            } else {
                this.password = this.confirmPassword;
                this.displayResetPwd = ! this.displayResetPwd;
                localStorage.setItem(this.userId+'userPwd', this.password)
                new ToastUtils().presentToast("Password reset successfully");
            }
        },
        displayResetOption() {
            this.newPassword = '';
            this.confirmPassword = '';
            this.displayResetPwd = ! this.displayResetPwd
        }
    }
})
</script>
<style scoped>

.download-file {
    font-size: 12px;
    background: #cc412c;
    color: white;
    border-radius: 5px;
    /* margin-right: 30px; */
}
.btn-primary1 {
    height: 52px;
    --background: #cc412c 0% 0% no-repeat padding-box;
    color: #ffffff;
    --background-focused: #cc412c !important;
    --background-hover: #cc412c !important;
    --webkit-background-focused: #cc412c !important;
    --webkit-background-hover: #cc412c !important;
    opacity: 1;
    font-weight: bold;
}
.close-btn {
    border: 1px solid #cc412c;
    margin-right: 30px;
    --background: #cc412c;
    color: white;
    border-radius: 5px; 
    opacity: 0.9;
    font-weight: bold;
    font-size: 10px;

}
.btn-clear {
    margin-top: 25px;
    font-family: "Roboto";
    font-size: 15px;
    letter-spacing: 0;
    color: #ffffff;
    height: 31px;
    --background: #b3b3b3 0% 0% no-repeat padding-box;
    --background-focused: #b3b3b3 !important;
    --background-hover: #b3b3b3 !important;
    --webkit-background-focused: #b3b3b3 !important;
    --webkit-background-hover: #b3b3b3 !important;
    border-radius: 3px;
    opacity: 1;
    bottom: 0;
}

.btn-clear1 {
    /* margin-top: 25px; */
    font-family: "Roboto";
    font-size: 15px;
    letter-spacing: 0;
    color: #ffffff;
    height: 31px;
    --background: #b3b3b3 0% 0% no-repeat padding-box;
    --background-focused: #b3b3b3 !important;
    --background-hover: #b3b3b3 !important;
    --webkit-background-focused: #b3b3b3 !important;
    --webkit-background-hover: #b3b3b3 !important;
    border-radius: 3px;
    opacity: 1;
    bottom: 0;
}
</style>